import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var Content = function Content(_ref) {
  var children = _ref.children;
  return _jsx(MenuContent, {
    children: children
  });
};

var MenuContent = /*#__PURE__*/_styled("div", true ? {
  target: "euhvmxs0"
} : {
  target: "euhvmxs0",
  label: "MenuContent"
})(true ? {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px"
} : {
  name: "hmxbog",
  styles: "display:flex;flex-direction:column;justify-content:space-between;gap:24px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvTmF2aWdhdGlvbjIvTW9iaWxlTmF2aWdhdGlvbi9Db250ZW50L0NvbnRlbnQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU04QiIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL05hdmlnYXRpb24yL01vYmlsZU5hdmlnYXRpb24vQ29udGVudC9Db250ZW50LnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgRkMsIFByb3BzV2l0aENoaWxkcmVuIH0gZnJvbSAncmVhY3QnXG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgQ29udGVudDogRkM8UHJvcHNXaXRoQ2hpbGRyZW4+ID0gKHsgY2hpbGRyZW4gfSkgPT4gPE1lbnVDb250ZW50PntjaGlsZHJlbn08L01lbnVDb250ZW50PlxuXG5jb25zdCBNZW51Q29udGVudCA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGp1c3RpZnktY29udGVudDogc3BhY2UtYmV0d2VlbjtcbiAgZ2FwOiAyNHB4O1xuYFxuXG5leHBvcnQgZGVmYXVsdCBDb250ZW50XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Content;